import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonIconButton } from '../IconButton/IconButton.definition';
import { chameleonCode } from './Code.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonCode({ prefix }), chameleonIconButton({ prefix }));
}
